<template>
  <div>
    <a-table
      :columns="columns"
      :rowKey="rowKey"
      :dataSource="tableData"
      :loading="loading"
      :pagination="false"
      @change="handleTableChange"
      :scroll="{ x:tableSize.width, y: tableSize.height }">
      <slot
        v-bind="record"
        slot="operation"
        slot-scope="record">
      </slot>
    </a-table>
    <a-pagination
      :pageSizeOptions="pagination.pageSizeOptions"
      :total="pagination.total"
      showSizeChanger
      :pageSize="pagination.pageSize"
      v-model="pagination.current"
      @showSizeChange="onShowSizeChange"
      @change="onPageChange"
      :showQuickJumper="true"
      style="float:right;margin-top:20px;"
      :showTotal="total => `共 ${ pagination.total } 条记录`"></a-pagination>
    <div style="clear:both;" />
  </div>
</template>
<script>
import log from '../libs/common/log';
export default {
  name: "JTable",
  props: [
    "tableColumns", //  { title: "用户账号", dataIndex: "user_code", key: "user_code", fixed: "left", align: "center" }
    "rowKey",
    "tableData",
    "loading",
    "tablePagination"
  ],
  data() {
    return {
      defaultPagination: {
        pageSize: 10,
        pageSizeOptions: ["10", "20", "30"],
        current: 1,
        total: 0
      },
      tableSize: {},
      operationWidth: 0
    };
  },
  computed: {
    columns() {
      return this.tableColumns;
    },
    pagination() {
      return this.tablePagination
        ? this.tablePagination
        : this.defaultPagination;
    }
  },
  created() {
    let columnCustomWidthSum = 0;
    let columnSum = 0;
    for (let i = 0; i < this.columns.length; i++) {
      if(this.columns[i]["width"] && this.columns[i]["width"] > 0) {
        columnCustomWidthSum += this.columns[i]["width"];  
        columnSum++;
      }
    }
    const clientWidth = document.body.clientWidth;
    const clientHeight = document.body.clientHeight;
    const preWidth = (this.columns.length - columnSum) * 150 + columnCustomWidthSum;
    const tableWidth = (clientWidth - 300) > preWidth ? (clientWidth - 300) : preWidth;
    
    this.tableSize = {
      width: tableWidth,
      height: clientHeight - 383
    };
    const eachWidth = Math.floor(
      (this.tableSize.width - columnCustomWidthSum) / (this.columns.length - columnSum)
    );
    for (let i = 0; i < this.columns.length; i++) {
      if(this.columns[i]["width"] && this.columns[i]["width"] > 0){
        continue;
      }else {
        this.columns[i]["width"] = eachWidth;
      }
    }
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      this.$log.error(JSON.stringify(sorter));
      let orderby = "";
      if (sorter && sorter.column) {
        let sortType;
        if (sorter.order === "ascend") {
          sortType = "asc";
        } else if (sorter.order === "descend") {
          sortType = "desc";
        }
        orderby = sorter.column.dataIndex + " " + sortType;
      }
      this.$emit("onOrderbyChange", orderby);
    },
    onShowSizeChange(current, pageSize) {
      this.pagination.pageSize = pageSize;
      this.$emit("onPaginationChange", this.pagination);
    },
    onPageChange(page) {
      this.pagination.current = page;
      this.$emit("onPaginationChange", this.pagination);
    }
  }
};
</script>
<style>
</style>